module.exports = __webpack_public_path__ + "img/0Q3B8222_WoodMatted.ffe3d28b.jpg";